// extracted by mini-css-extract-plugin
module.exports = {"container":"Separator-container-l5Ojq","top":"Separator-top-HnrIy","bottom":"Separator-bottom-3Mtym"};